import { store } from "@/store/store";

export const getHostname = () => {
  const hostname = window.location.hostname;
  if (!hostname || hostname === 'mobile.qashqool.com') {
    return store.getState().hostname.hostname;
  }
  return hostname;
};
